import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFixedAssetBalanceApi } from "../../../apiservice/reports";

export const fetchFixedAssetBalance = createAsyncThunk(
  "fixedAssetBalance/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        accId:
          filters.type == "Fixed Asset Account Wise" ? filters.accId : null,
        fromDate: filters.type == "Date Wise" ? filters.fromDate : null,
        toDate: filters.type == "Date Wise" ? filters.toDate : null,
      };
      const res = await getFixedAssetBalanceApi(payload);
      return {
        list: res.data?.assets || [],
        total_balance: res.data?.total_balance || 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
